import { cUtil } from "../../functions/util";

export interface cDateFieldPrams {
    validDates      : string[], 
    initDate        : string,
    label           : string,
    placeholder     : string,
    parentElm       : HTMLElement, 
    parentObj       : DateFieldTop,
    eventDefault    : string,
    cssClass        : string,
    emptyAllowed    : boolean,
}

export class cDateField implements DateFieldTop{

  fieldset    = document.createElement('fieldset');
  label       = document.createElement('label');
  div_wrapper = document.createElement('div');
  input       = document.createElement('input');
  span_icon   = document.createElement('span');
  p_error     = document.createElement('p');

  tail               : any;
  validDates         : string[];
  parentObj          : DateFieldTop;
  defaultEventSource : string;
  setDateEventSource : string;
  emptyAllowed       : boolean;
  
  constructor(params: cDateFieldPrams) {

    this.validDates         = params.validDates;
    this.parentObj          = params.parentObj;
    this.defaultEventSource = params.eventDefault;
    this.emptyAllowed       = params.emptyAllowed;
    this.setDateEventSource = '';

    // ---- Structure ----
    params.parentElm.append(this.fieldset);
      this.fieldset.append(this.label);
      this.fieldset.append(this.div_wrapper);
        this.div_wrapper.append(this.input);
        this.div_wrapper.append(this.span_icon);
      this.fieldset.append(this.p_error);

    // ---- Texts ----
    this.label.innerText   = params.label;
    this.input.placeholder = params.placeholder;

    // ---- Label Ids ----
    cUtil.labelIds(this.label, this.input);

    // ---- Classes ----
    this.fieldset.classList.add('c-date-field');
    this.fieldset.classList.add(params.cssClass);

    // ---- Other ----
    this.input.type = 'text';

    // ---- Init ----
    this.tail = tail.DateTime(this.input, {
      timeFormat    : false,
      today         : false,
      weekStart     : 1,
      closeButton   : false,
      dateFormat    : 'dd.mm.YYYY',
      locale        : cUtil.locale(),
      dateBlacklist : this.validDates.length === 0,
    });

    if (this.validDates.length !== 0) {
      this.setValidDates(this.validDates);
      this.setDate(params.initDate, 'init');
    }
    else {
      this.setDate(params.initDate, 'init');
    }


    // ---- Events ----
    this.input.addEventListener('change', (e) => {
      const eventSource =
        this.setDateEventSource !== '' 
        ? this.setDateEventSource
        : this.defaultEventSource;

      this.setDateEventSource = '';
      params.parentObj.changeEvent(eventSource);
    });

    this.input.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' && event.key !== 'Enter') return;
      this.tail.close();
    });

    this.div_wrapper.addEventListener('click', () => {
      this.tail.open();
    });

  }

  setValidDates(validDates: string[]) {
    this.validDates = validDates;

    const dateRanges = this.validDates.map(date => {
      return {
        start : cUtil.isoToUnix(date),
        end   : cUtil.isoToUnix(date),
        days  : true,
      };
    });
    this.setDateEventSource = '';
    this.tail.config('dateRanges', dateRanges);
  }

  getDate(): string {
    const isoDate  = cUtil.chToIso(this.input.value)
    const dateText =  isoDate === '1970-01-01' ? '' : isoDate;
    return dateText;
  }
  
  /**
   * 
   * @param date ISO Date
   */
  setDate(date: string, eventSource: string = 'noop') {
    
    const textDate =
      date === ''           ? '' :
      date === '1970-01-01' ? '' :
      /*else*/ cUtil.isoToCh(date);

    if (textDate !== '' && eventSource !== 'init') {
      // tail does artificially trigger change on input elements
      // but not when clearing the field
      this.setDateEventSource = 'noop';
    }  

    this.input.value  = textDate;
    this.tail.reload();
  }

  validateItem(silent: 'silent'|'', message: 'list'|'', isSelected?: boolean): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    const input      = this.input.value;
    const isEmpty    = input.length === 0;
    const isDate     = cUtil.validateCh(input);
    const date       = this.getDate();
    const isFreeDate = 
      this.validDates.length === 0 ||
      Boolean(
        this.validDates
        .filter(vDate => vDate === date)
        .length === 1
      );

    const notFreeDateMsg = message === 'list' ? 
      __('Diese Liste enthält Produkte, die an diesem Datum nicht geliefert werden können.', 'custom') : 
      __('Dieses Produkt kann an diesem Datum nicht geliefert werden.', 'custom');

    const errorMsg =
      isEmpty && this.emptyAllowed  ? ''                                          :
      isEmpty && !this.emptyAllowed ? __('Datum fehlt.')                          : 
      !isDate                       ? __('Kein gültiges Datumsformat.', 'custom') :
      !isFreeDate                   ? notFreeDateMsg                              :
      /*else*/ '';

    const hasError = errorMsg.length > 0;

      if (silent !== 'silent' && hasError) {
        this.setError(errorMsg);
      }
      else {
        this.removeError();
      }

    return Boolean(errorMsg.length === 0);
  }

  setError(errorMsg: string) {
    this.p_error.innerText = errorMsg;
    this.p_error.classList.add('c--error');
    this.div_wrapper.classList.add('c--error-marker');
  }

  removeError() {
    this.p_error.innerText = '';
    this.p_error.classList.remove('c--error');
    this.div_wrapper.classList.remove('c--error-marker');
  }

  setTabIndex(index: number) {
    this.input.tabIndex = index;
  }

  changeEvent(eventSource: string): void {
  }
}